import React, { useState, useEffect } from "react";
import FooterNew from "../components/Footer-New.js";
import NavbarInner from "../components/Navbar-Inner";
import CreateTicket from "../components/Support/CreateTicket.js";
import TicketList from "../components/Support/TicketList.js";
import NavbarInnerSide from "../components/NavbarInnerSide.js";
import Sidebar from "../components/Sidebar.js";



export default function SupportTicket(props) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <div>
     
      {/* <NavbarInner /> */}
      <NavbarInnerSide toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)} />
      <div className="flex w-full relative">
        <Sidebar isOpen={isSidebarOpen} closeSidebar={() => setIsSidebarOpen(false)} />
        <div className="flex-1 w-full overflow-hidden p-4">
          <div className="rounded-sm outline outline-1 outline-offset-[-1px] outline-[#6B7280]/25 p-4 flex flex-col lg:flex-row gap-6 lg:gap-8 items-start min-h-[calc(100vh-96px)]">
            
              <CreateTicket />
            
           
              <TicketList />
           
          </div>
        </div>
      </div>
      {/* <FooterNew/> */}
    </div>
  );
}
